<template>
    <div>
        <!-- header -->
        <Mynav></Mynav>
        <div class="wrapper">
            <div class="topBg"></div>
            <div class="contact-box">
                <div class="left">
                    <div class="Contact-items transition" v-for="(item,index) in ContactList" :key="index">
                        <div class="Contact-items-top">
                            <p>{{item.title}}</p>
                            <p>{{item.mail}}</p>
                        </div>
                        <!-- <div class="Contact-items-bottom">Leave Message</div> -->
                    </div>
                </div>
				<!--
                <div class="right">
                    <div class="input-box">
                        <div class="input-item" v-for="(item,index) in inputList" :key="index">
                            <p>{{item.title}}</p>
                            <input type="text" @focus="focus(index)" @blur="blur(index)" :data-index="item.title" v-model="item.value" />
                            <div :style="item.border?'background-color:rgb(0,123,247);':''" class="border-bottom transition"></div>
                        </div>
                    </div>
                    <div class="textarea-box">
                        <div class="textarea-item">
                            <p>Subject*</p>
                            <textarea @focus="textareafocus" @blur="textareablur" v-model="subject" />
                            <div class="border-bottom transition" :style="textareaBorder?'background-color:rgb(0,123,247);':''"></div>
                        </div>
                    </div>
                    btn
                    <div class="send-btn transition" @click="send">SEND</div>
                </div>
				-->
            </div>
        </div>
        <!-- footer -->
        <Myfooter></Myfooter>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                subject:'',
                inputIndex:'',
                textareaBorder:false,
                inputList:[{
                    title:'Name*',
                    type:'name',
                    value:'',
                    border:false,
                },{
                    title:'Email*',
                    type:'Email',
                    value:'',
                    border:false,
                },{
                    title:'Subject*',
                    Subject:'',
                    value:'',
                    border:false,
                }],
                ContactList:[
                    {
                    		title: 'Contact BD Team',
                    		mail: 'jiangkan@gamejoygames.com'
                    	},
                    	{
                    		title: 'Contact Development Team',
                    		mail: 'wangleiqiang@gamejoygames.com'
                    	}
                ],
            }
        },
        created() { },
        mounted() {
            
        },
        methods: {
            focus(index){
                let inputList = this.inputList;
                this.inputIndex = index;
                inputList[index].border = true;
                this.inputList = inputList;
            },
            blur(index){
                let inputList = this.inputList;
                this.inputIndex = '';
                inputList[index].border = false;
                this.inputList = inputList;
            },
            send(){
                console.log(this.inputList,this.subject)
            },
            textareafocus(e){
                this.textareaBorder = true;
            },
            textareablur(e){
                this.textareaBorder = false;
            }
        },
    }
</script>

<style scoped lang="scss">
    @import 'index';
</style>